'use client'
import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box } from "@mui/material";
import SubAccordionDetails from "./SubAccordionDetails";
import { accordionTitleConstants, subAccordionConstants } from "./GetTrayComponentsForThreeDBuilder";
import { gtmClickTracking } from "@/utils";
// import { RoomModel } from '@/store/builderSlice';
// import BuilderSelect from "@/store/builderStoreSelector";
export interface AccordionItem {
    id: string;
    accordionTitle: string;
    panel: string;
    apiUrl: string;
}
export interface SubAccordionData {
    title: string;
    accordions: AccordionItem[];
}
export interface SubAccordionProps {
    accordionData: SubAccordionData;
    isShowcaseFlow: boolean;
    handleMenuCloseDesignDetail: (isCloseMenu: boolean) => void;
    handleSelectedDesignDetailId: (itemId: string) => void;
    handleMoreItemsClosed: (isCloseMenu: boolean) => void;
    handleActiveAccordion: (activeAccordion: any) => void;
    handleItems: (items: any) => void;
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
}


export const designRoomTypeMap: { [key: string]: string } = {
    'Bedroom': 'bedroom',
    'Bed Room': 'bedroom',
    'Living Room': 'livingroom',
    'Dining Room': 'diningroom',
    'Home Office': 'homeoffice'
}
const SubAccordion: React.FC<SubAccordionProps> = (props) => {
    console.log('SubAccordion component start-------------------')
    //props
    const { accordionData, isShowcaseFlow, handleMenuCloseDesignDetail, handleSelectedDesignDetailId, handleMoreItemsClosed, handleActiveAccordion, handleItems, handleCloseProductDetails, handleSelectedProductDetailId } = props
    const { title, accordions } = accordionData
    //states
    const [expanded, setExpanded] = useState<string | false>(false);
    //store
    //inorder to get the room type we need currentRoomId ,roomModels ,currentRoomModel
    // const currentRoomId: string = BuilderSelect.activeSelection().roomId;
    // const roomModels: RoomModel[] = BuilderSelect.roomModels().models;
    // const currentRoomModel = roomModels.find(roomModel => roomModel.roomId === currentRoomId);
    //roomtype, currentDesignId, currentStyle are required for getting the current applied design to the room
    // const roomType: string = currentRoomModel ? (designRoomTypeMap[currentRoomModel.roomType] || currentRoomModel.roomType.toLowerCase()) : '';
    // const currentDesignId: string = BuilderSelect.ui().designId;
    // const currentStyle: string = BuilderSelect.ui().styleName;
    //effects
    useEffect(() => {
        //this effect is only used for style the scroll-bar
        const style = document.createElement("style");
        style.innerHTML = `
            .custom_inner_accordion {
                overflow-y: auto;
                scrollbar-width: thin; /* Firefox */
                scrollbar-color: transparent transparent; /* Make scrollbar transparent */
            }
            .custom_inner_accordion::-webkit-scrollbar {
                width: 4px;
            }
            .custom_inner_accordion::-webkit-scrollbar-thumb {
                background-color: transparent; /* Make thumb transparent */
                border-radius: 8px;
            }
            .custom_inner_accordion::-webkit-scrollbar-track {
                background: transparent;
            }
            /* On hover, make scrollbar visible */
            .custom_inner_accordion:hover {
                scrollbar-color: #0D908E transparent;
            }
            .custom_inner_accordion:hover::-webkit-scrollbar-thumb {
                background-color: #0D908E;
                border-radius: 8px; /* Keep rounded edges */
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);
    //handlers
    const handleChange = (panel: string, accordionTitle: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
        if (title === accordionTitleConstants.designs) {
            if (accordionTitle === subAccordionConstants.favorited) {
                gtmClickTracking({ event: 'favorited_designs' })
            }
            if (accordionTitle === subAccordionConstants.recentlyViewed) {
                gtmClickTracking({ event: 'recently_viewed_designs' })
            }
            if (accordionTitle === subAccordionConstants.designs) {
                gtmClickTracking({ event: 'all_designs' })
            }
        }
        if (title === accordionTitleConstants.products) {
            if (accordionTitle === subAccordionConstants.favorited) {
                gtmClickTracking({ event: 'favorited_products' })
            }
            if (accordionTitle === subAccordionConstants.recentlyViewed) {
                gtmClickTracking({ event: 'recently_viewed_products' })
            }
            if (accordionTitle === subAccordionConstants.products) {
                gtmClickTracking({ event: 'all_products' })
            }
        }
    };
    //root return jsx
    return (
        <>
            <div className="custom_inner_accordion" style={{
                overflowY: 'auto',
            }}>
                {accordions.map((eachAccordion: AccordionItem) => (
                    <Accordion expanded={expanded === eachAccordion.panel} onChange={handleChange(eachAccordion.panel, eachAccordion.accordionTitle)} key={eachAccordion.id}>
                        <AccordionSummary expandIcon={expanded === eachAccordion.panel ? <KeyboardArrowUpIcon sx={{ fontSize: '18px', color: '#000' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: '18px', color: '#000' }} />}>
                            <Typography>{eachAccordion.accordionTitle} <Box component="span" sx={{ color: '#25282B' }}></Box></Typography>
                        </AccordionSummary>
                        <AccordionDetails >
                            <SubAccordionDetails
                                eachAccordion={eachAccordion}
                                expanded={expanded === eachAccordion.panel}
                                parentAccordion={title}
                                isShowcaseFlow={isShowcaseFlow}
                                handleMenuCloseDesignDetail={handleMenuCloseDesignDetail}
                                handleSelectedDesignDetailId={handleSelectedDesignDetailId}
                                handleMoreItemsClosed={handleMoreItemsClosed}
                                handleActiveAccordion={handleActiveAccordion}
                                handleItems={handleItems}
                                handleCloseProductDetails={handleCloseProductDetails}
                                handleSelectedProductDetailId={handleSelectedProductDetailId}
                            />
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
        </>
    );
};

export default SubAccordion;